import React from "react";
import "./ShipmentUpdateEmpty.scss";
import { getIcon } from "../../../utils/images";

const ShipmentUpdateEmpty = ({isAttention}) => {

  return (
    <div className="ShipmentUpdateEmpty">
      <div>
        <img src={getIcon('no-attentions')}/>
      </div>
      <div className="headline">
        { isAttention ? "No Attentions" : "No Updates" }
      </div>
      <div className="sub-headline">
        You're up to date
      </div>
    </div>
  )
}

export default ShipmentUpdateEmpty;
